
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class BlackAprilJudithBanner extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  readonly title!: string

  get srcsetStr () {
    return `${this.pictures[0]} 1x, ${this.pictures[1]} 2x`
  }

  get pictures () {
    return [
      require('~/assets/images/promos/valentine/features-banner-image.webp'),
      require('~/assets/images/promos/valentine/features-banner-image@2x.webp'),
    ]
  }
}
